<template>
  <div class="d-flex w-full " v-if="params.value!=='-'&&params.value !== null&&params.value !== undefined ">
    <p class=""> {{ parseFloatValue}} THB</p>
   
  </div>
  <div v-else class="d-flex w-full justify-content-center">
 <p> -</p>
  </div>
</template>

<script>
export default {
  mounted() {
    // console.log("params", this.params.value === null);

  },
  methods: {
  
  },
  computed: {
    parseFloatValue() {
      return this.params.value !== undefined &&this.params.value !== null ?
       parseFloat(this.params.value).toFixed(2).toLocaleString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):
       "-"
    }
  },
};
</script>
